module.exports = __webpack_public_path__ + "img/csr_swiper_02_03.ec5fa069.jpg";